export default {
  restaurantdeals: {
    shop_by: "تسوق حسب",
    category: "الفئة",
    popular_categories: "الفئات الشائعة",
    loading: "جاري تحميل الفئات...",
    no_data: "لا توجد فئات",
  },
};